export function formatString(input = '') {
  // Ensure input is a string
  if (typeof input !== 'string') {
    return '';
  }
  let formatted = input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
  formatted = formatted.replace(/_([a-zA-Z])/g, (letter) => ` ${letter.toUpperCase()}`);
  return formatted;
}

export function convertToTitleCase(input: string): string {
  return input
    .split('_') // Split by underscore
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(' '); // Join with space
}

export function formatToCSTString(dateStr: string): string {
  const date = new Date(dateStr);

  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago', // CST/CDT
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  });

  return formatter.format(date); // e.g., "05/06/25, 02:36 AM CDT"
}

export interface FormatPercentage {
  (value: number | string): string;
}

export const formatPercentage: FormatPercentage = (value) => {
  // Convert to number if it's not already
  const numValue = Number(value);

  // Check if the value is a whole number
  if (numValue === Math.floor(numValue)) {
    // If it's a whole number, show no decimal places
    return Math.floor(numValue) + '%';
  } else {
    // If it has decimal places, show 2 decimal places
    return numValue.toFixed(2) + '%';
  }
};
